import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, IconButton, Typography
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

function TablaPreguntas({ preguntas, onEditar, onEliminar }) {
    return (
        <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ p: 2 }}>Preguntas agregadas</Typography>

            <Table>
                <TableHead>
                    <TableRow key={0}>
                        <TableCell>Pregunta</TableCell>
                        <TableCell>Respuestas</TableCell>
                        <TableCell>Tema</TableCell>
                        <TableCell align="center">Acciones</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {preguntas.map((pregunta) => (
                        <TableRow key={pregunta.id_pregunta}>
                            <TableCell>{pregunta.texto_pregunta}</TableCell>
                            <TableCell>
                                {pregunta.opciones_respuesta
                                    ? pregunta.opciones_respuesta.split('|').map((r, i) => <div key={i}>{r}</div>)
                                    : '—'}
                            </TableCell>
                            <TableCell>{pregunta.nombre_tema || '—'}</TableCell>
                            <TableCell align="center">
                                <IconButton onClick={() => onEditar(pregunta)}>
                                    <Edit />
                                </IconButton>
                                <IconButton onClick={() => onEliminar(pregunta.id_pregunta)}>
                                    <Delete />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}

                    {preguntas.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                No hay preguntas agregadas aún.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default TablaPreguntas;